import {
  Box,
  Card,
  CardActionArea,
  Grid,
  Link,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Typography } from "@mui/material";
import { ColoredCard } from "./ColoredCard";
import { ChevronRight } from "@mui/icons-material";

const guides: Array<{
  name: string;
  image: string;
  darkImage?: string;
  link: string;
}> = [
  {
    name: "Chrome",
    image: "chrome",
    link: "https://www.webshare.io/blog/chrome-proxy-settings",
  },
  {
    name: "Firefox",
    image: "firefox",
    link: "https://www.webshare.io/blog/firefox-proxy",
  },
  {
    name: "Telegram",
    image: "telegram",
    link: "https://www.webshare.io/blog/telegram-proxy",
  },
  {
    name: "WhatsApp",
    image: "whatsapp",
    link: "https://www.webshare.io/blog/whatsapp-proxy",
  },
  {
    name: "Tik Tok",
    image: "tiktok",
    link: "https://www.webshare.io/blog/tiktok-proxy",
  },
  {
    name: "Android",
    image: "android",
    link: "https://www.webshare.io/blog/android-free-proxy",
  },
  {
    name: "Gologin",
    image: "gologin",
    link: "https://www.webshare.io/blog/how-to-set-up-proxies-for-gologin",
  },
  {
    name: "MoreLogin",
    image: "morelogin",
    link: "https://www.webshare.io/blog/how-to-set-up-proxies-for-morelogin",
  },
  {
    name: "Iphone",
    image: "iphone",
    // A black wordmark, so the dark theme draws its white copy (R-2260).
    darkImage: "iphone-dark",
    link: "https://www.webshare.io/blog/how-to-configure-proxies-on-iphone",
  },
  {
    name: "Windows",
    image: "windows",
    link: "https://www.webshare.io/blog/windows-proxy",
  },
];

export default function DashboardArticles() {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isDark = theme.palette.mode === "dark";
  const size = isXs ? 22 : 30;
  return (
    <Box sx={{ p: 3, pt: 0 }}>
      <Card sx={{ p: 3 }}>
        <Typography variant="h6">Popular Proxy Setup Guides</Typography>
        <Typography variant="body2" sx={{ mb: 3 }}>
          Learn how to use your proxies on the most popular apps and platforms.
        </Typography>

        <Grid container columns={10} spacing={2}>
          {guides.map((guide) => {
            return (
              <Grid key={guide.name} size={{ xs: 5, md: 2, xl: 1 }}>
                <CardActionArea
                  key={guide.name}
                  LinkComponent={Link}
                  href={guide.link}
                  target="_blank"
                >
                  <ColoredCard
                    type="greyMid"
                    sx={{
                      borderColor: "divider",
                      borderWidth: 1,
                      borderStyle: "solid",
                      p: 2,
                    }}
                  >
                    <Stack
                      direction={{ xs: "row", md: "column" }}
                      alignItems={"center"}
                      justifyContent={{ xs: "space-between", md: "flex-start" }}
                    >
                      <Stack
                        direction={{ xs: "row", md: "column" }}
                        spacing={1}
                        alignItems="center"
                      >
                        <img
                          loading="lazy"
                          decoding="async"
                          src={`/guides/${(isDark && guide.darkImage) || guide.image}.png`}
                          alt={guide.name}
                          width={size}
                          height={size}
                        />
                        <Typography variant={isXs ? "subtitle2" : "caption"}>
                          {guide.name}
                        </Typography>
                      </Stack>
                      <ChevronRight
                        sx={{
                          fontSize: 20,
                          display: { md: "none", xs: "block" },
                        }}
                      />
                    </Stack>
                  </ColoredCard>
                </CardActionArea>
              </Grid>
            );
          })}
        </Grid>
      </Card>
    </Box>
  );
}
